export const errorObject = { e: {} };
